import React from 'react';

/**
 * GradientText Component
 *
 * A flexible component for applying gradient styling to headings and text.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The text content to apply gradient to
 * @param {string} [props.as='span'] - The HTML element to render (h1, h2, h3, h4, h5, h6, p, span, etc.)
 * @param {string} [props.variant='light'] - Gradient variant ('light', 'dark')
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {Object} [props.style={}] - Additional inline styles
 * @param {Object} props.rest - Additional props to pass to the element
 */
const GradientText = ({
  children,
  as: Component = 'span',
  variant = 'lightGrey',
  className = '',
  style = {},
  ...rest
}) => {
  const gradients = {
    lightPurple:
      'linear-gradient(135deg, #FFFFFF 0%, #a892e6 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
    purple:
      'linear-gradient(135deg, #FFFFFF 0%,#6042b3 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
    blue: 'linear-gradient(135deg, #FFFFFF 0%, #2960BA 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
    lightBlue:
      'linear-gradient(135deg, #FFFFFF 0%, #2B7DA0 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
    teal: 'linear-gradient(135deg, #FFFFFF 0%, #36C1DA 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
    lightGrey:
      'linear-gradient(135deg, #FFFFFF 0%, #71717A 100%), linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))'
  };

  const gradientStyle = {
    flex: 1,
    background: gradients[variant] || gradients.lightGrey,
    clipPath: 'content-box',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text', // For webkit browsers
    color: 'transparent',
    display: 'inline-block',
    ...style
  };

  return (
    <Component className={className} style={gradientStyle} {...rest}>
      {children}
    </Component>
  );
};

export default GradientText;
